import _extends from "@babel/runtime/helpers/esm/extends";
import { GridWorkspacesIcon, GridGroupWorkIcon, GridFunctionsIcon } from "./icons.js";
const iconsSlots = {
  columnMenuUngroupIcon: GridWorkspacesIcon,
  columnMenuGroupIcon: GridGroupWorkIcon,
  columnMenuAggregationIcon: GridFunctionsIcon
};
const materialSlots = _extends({}, iconsSlots);
export default materialSlots;